import { createTheme } from "@mui/material/styles";

// Gulf-coast palette: deep teal and coral over a sandy off-white background.
const theme = createTheme({
  palette: {
    primary: { main: "#00687b", dark: "#004a58", light: "#4d95a4" },
    secondary: { main: "#ee6f57" },
    background: { default: "#f4f8f9", paper: "#ffffff" },
  },
  shape: { borderRadius: 10 },
  typography: {
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(115deg, #004a58 0%, #00687b 55%, #00829a 100%)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: "1px solid #e2ecee",
          boxShadow: "0 8px 24px rgba(0, 74, 88, 0.08)",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 14 },
      },
    },
  },
});

export default theme;
